import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'fgbcl-game-predictor-unsaved-warning-modal',
  templateUrl: './game-predictor-unsaved-warning-modal.component.html',
  styleUrl: './game-predictor-unsaved-warning-modal.component.scss',
})
export class GamePredictorUnsavedWarningModalComponent {
  @Output() confirm = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();

  onConfirm(): void {
    this.confirm.emit();
  }

  onCancel(): void {
    this.cancel.emit();
  }
}
